/* eslint-disable no-shadow */
const state = {
	scope: 'users',
	limit: 20,
};

const getters = {

};

const mutations = {

};

const actions = {
	'users/list': async function ({ dispatch, commit, state, getters }, { reset = false, search }) {
		commit('SET_DATA_LOADING', { value: true, type: state.scope });

		let offset;
		if (reset) offset = 0; else offset = getters[`data/${state.scope}`].results.length;
		const users = await this.$sdk.admin().users.list({ offset, search, limit: state.limit });

		if (users.ok) dispatch('addData', { data: users.data, type: state.scope, reset });

		const result = {
			ok: false,
			state: 'complete',
		};

		if (users.ok) {
			result.ok = true;

			dispatch('addData', { data: users.data, type: state.scope, reset });

			if (offset < users.data.total) result.state = 'loaded';
		}

		commit('SET_DATA_LOADING', { value: false, type: state.scope });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
